import { atBqnTarget, safeStr } from "common/api";

// The rates of every subscriber, of one subscriber group or of all of them,
// by IP address or by subscriber ID.
export const liveThroughputCommand = ({ output, subscriberGroup }) => {
  const bySubscriberId = output === "subscriber-ids" ? " subscriber-id" : "";
  const ofGroup =
    subscriberGroup === "all-subscribers"
      ? ""
      : ` subscriber-group ${safeStr(subscriberGroup)}`;

  return `show subscriber all rates${bySubscriberId}${ofGroup} lines 19`;
};

// The data of the BQN selected in the header, or of the whole cluster.

export const liveThroughputRetrieval = ({
  output,
  subscriberGroup,
  mode,
  bqnId,
}) =>
  ifCl.run(
    atBqnTarget(liveThroughputCommand({ output, subscriberGroup }), mode, bqnId)
  );

export const subscriberGroupsRetrieval = (mode, bqnId) =>
  ifCl.run(atBqnTarget("show api subscriber-group", mode, bqnId));
